import store from '@/store'

/** 侧栏是否展示「订单管理 → Hold房单列表」菜单项 */
export function hasHoldOrderSidebarBadgeMenu(routers) {
  const list = routers || []
  const oms = list.find(r => r.name === 'oms')
  if (!oms || !oms.children || !oms.children.length) return false
  return oms.children.some(c => !c.hidden && c.name === 'holdOrderList')
}

export function canRefreshHoldSidebarBadge() {
  const getters = store.getters
  return hasHoldOrderSidebarBadgeMenu(getters.routers) && getters.hasOrderResource
}

/** 条件变化后立即刷新 Hold 房单取消提醒角标（取消日为今天或已过期；无权限时 no-op） */
export function refreshHoldSidebarBadge() {
  if (!canRefreshHoldSidebarBadge()) {
    return Promise.resolve()
  }
  return store.dispatch('FetchHoldCancellationTodayCount')
}



// WEBPACK FOOTER //
// ./src/utils/holdSidebarBadge.js